import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { baseStyles, baseStylesNoReset } from '../../BaseTheme';
import { colors } from './colors';
import { baseFonts } from '../../BaseFonts';
import { baseTypography, baseTypographyHeaders, baseTypographyNoDefault, baseTypographyHeadersNoDefault, BaseTypographyLoader } from '../../BaseTypography';
import { defaultTypography } from '../typography';
export var UI_THEME = {};
export var GlobalStyles = /*#__PURE__*/createGlobalStyle(["", ";:root{", ";", ";}", ";", ";", ";"], baseStyles, baseFonts, colors, baseTypographyHeaders, baseTypography, defaultTypography);
export var GlobalStylesNoDefault = /*#__PURE__*/createGlobalStyle(["", ";:root{", ";", ";}", ";", ";"], baseStylesNoReset, baseFonts, colors, baseTypographyHeadersNoDefault, baseTypographyNoDefault);

var _ref2 = /*#__PURE__*/React.createElement(BaseTypographyLoader, null);

var _ref3 = /*#__PURE__*/React.createElement(GlobalStyles, null);

var _ref4 = /*#__PURE__*/React.createElement(GlobalStylesNoDefault, null);

var GlobalComponents = function GlobalComponents(_ref) {
  var _ref$useDefaults = _ref.useDefaults,
      useDefaults = _ref$useDefaults === void 0 ? true : _ref$useDefaults;
  return /*#__PURE__*/React.createElement(React.Fragment, null, _ref2, useDefaults && _ref3, !useDefaults && _ref4);
};

export default GlobalComponents;